import axios from 'axios'
import { getToken } from './storage'

const SOURCE = 'H5'

const http = axios.create({
  baseURL: ''
})

// 请求拦截器===  在发送请求之前
http.interceptors.request.use(function (config) {
  if (config.data && !config.data.source) {
    config.data.source = SOURCE
  }

  const userToken = getToken()
  if (userToken) {
    config.headers['X-user-token'] = userToken
  }
  return config
}, function (error) { // 请求错误
  return Promise.reject(error)
})

export default http



// WEBPACK FOOTER //
// ./src/npm/monitor/platform/h5/request.js